import React, { createContext, useContext, useState, useEffect } from 'react';
import configService from '../services/configService';

const ConstantsContext = createContext(null);
export const useConstants = () => useContext(ConstantsContext);

export const ConstantsProvider = ({ children }) => {
  const [constants, setConstants] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    configService.getAppConstants()
      .then(data => {
        setConstants(data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error("Failed to load app constants", err);
        setIsLoading(false);
      });
  }, []);

  return (
    <ConstantsContext.Provider value={{ constants, isLoading }}>
      {!isLoading && children}
    </ConstantsContext.Provider>
  );
};